
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/finances/settings",
      function () {
        return require("private-next-pages/[company]/finances/settings.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/finances/settings"])
      });
    }
  